/**
 * Labstep
 *
 * @module core/Modal/Default/Header
 * @desc Generic Modal Header component with Done button
 */

import { Button } from 'labstep-web/core/Button';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { IModalDefaultHeaderProps } from './types';

export const ModalDefaultHeader: React.FC<
  IModalDefaultHeaderProps
> = ({ icon, text, onClose, extraActions }) => (
  <Flex
    vAlignContent="center"
    style={{ justifyContent: 'space-between' }}
  >
    <div>
      {icon && <Icon name={icon} />}
      {text}
    </div>
    <Flex vAlignContent="center" spacing="gap">
      {extraActions && extraActions.map((action) => <>{action}</>)}
      <Button primary onClick={onClose}>
        Done
      </Button>
    </Flex>
  </Flex>
);
